/**
 * External links used across the app, kept here so each one is edited in one place.
 */

/** The PARAS/PARASECT paper in JACS Au. */
export const PUBLICATION_URL = 'https://pubs.acs.org/jaaucr/article/6/4/2315/5145284/PARAS-High-Accuracy-Machine-Learning-of-Substrate';

export const GITHUB_URL = 'https://github.com/BTheDragonMaster/parasect';
export const GITHUB_ISSUES_URL = `${GITHUB_URL}/issues`;

/** CC BY 4.0 terms for the database and dataset files. */
export const DATABASE_LICENSE_URL = `${GITHUB_URL}/blob/master/LICENSE-DATABASE.txt`;
